const zhLogin = {
    'CMS_PC_PUBLISH_TIME':"发表时间：",
}

const enLogin = {
    'CMS_PC_PUBLISH_TIME':"Published:",
}

const frLogin = {
    'CMS_PC_PUBLISH_TIME':"Publié:",
}

export default {
    zhLogin,
    enLogin,
    frLogin
}